import { apiClient } from "../api";

export const getPortfolio = async () => {
  const res = await apiClient.get("/portfolio");
  return res.data;
};

export const createPortfolio = async (formData) => {
  const res = await apiClient.post("/portfolio", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updatePortfolio = async (id, formData) => {
  formData.append("_method", "PUT");
  const res = await apiClient.post(`/portfolio/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deletePortfolio = async (id) => {
  const res = await apiClient.delete(`/portfolio/${id}`);
  return res.data;
};